export default __webpack_public_path__ + "static/media/skillset-infrastructure.fb7222d4.svg";